import FundRequestsUpdates from './Cards/FundRequestsUpdates';
import SavedSearches from './Cards/SavedSearches';
import GrantRecipients from './Cards/GrantRecipients';

const FinancialCoordinatorDashboard = () => {
    return (
        <>
            <FundRequestsUpdates />

            <section className='grid grid-cols-12 gap-7.5'>
                <div className='col-span-12 mb-7.5 xl:col-span-6'>
                    <SavedSearches />
                </div>

                <div className='col-span-12 mb-7.5 xl:col-span-6'>
                    <GrantRecipients />
                </div>
            </section>
        </>
    );
};

export default FinancialCoordinatorDashboard;
